import React, { useState,useRef,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import bars from '../assets/bars.png';
import countryFlag from '../assets/country_flag.png';
import notification from '../assets/notification.png';
import mode from '../assets/mode.png';
import ProfileImage from '../assets/Post1.png';
import Search1 from '../assets/search.png';
import Logo from '../assets/SnaptaLogo.png'
import { Link } from 'react-router-dom';
import { useGetDetailsQuery } from '../store/api/GetProfileDetails';
import Cookies from 'js-cookie'
import { useTheme } from '../context/ThemeProvider'; //For Light Dark Mode
import Moon from '../assets/moon.png'
import { IoIosNotificationsOutline } from "react-icons/io";
import { TbSunLow } from "react-icons/tb";
import { AiOutlineMoon } from "react-icons/ai";
import Sidebar from '../pages/Sidebar/Sidebar';
import SearchDialog from './AllPagesSearchDialog'
import { FaBars } from "react-icons/fa6";
import NotificationPopup from './NotificationPopup'
import { useGetAllNotificationQuery } from '../store/api/AllNotificationList';
import LogoutProfilePopup from './LogoutProfilePopup'
import LogoutDialog from '../pages/Logout/LogoutPopup'

const searchOptions = [
    { name: "Dashboard", path: "/dashboard" },
    { name: "User List", path: "/user-list" },
    { name: "Post List", path: "/post-list" },
    { name: "Reel List", path: "/reel-list" },
    { name: "User Report List", path: "/user-report-list" },
    { name: "Post Report List", path: "/post-report-list" },
    { name: "Reel Report List", path: "/reel-report-list" },
    { name: "Profile", path: "/profile" },
    { name: "Stories List", path: "/stories-list" },
    { name: "Push Notification", path: "/push-notification" },
    { name: "Hashtag List", path: "/hashtag-list"},
    { name: "Language List", path: "/language-list"},
    { name: "Music List", path:'/music-list'},
    { name: "Block List", path:'/block-list'},
    { name: "Avtar List", path:'/avtar-list'},
];

function Search() {
    const [search, setSearch] = useState("");
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [open,setOpen] = useState(false)
    const [openNotification,setOpenNotification] = useState(false)
    const [popupOpen,setPopupOpen] = useState(false)

    const filteredOptions = search
        ? searchOptions.filter(option =>
            option.name.toLowerCase().includes(search.toLowerCase())
        )
        : [];

        const notificationRef = useRef()
        const logoutRef = useRef()
        const profileRef = useRef()

      useEffect(() => {
  const handleClickOutside = (event) => {
    // For Notification Popup
    if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target)
    ) {
      setOpenNotification(false);
    }

    // For Profile Popup
    if (
      profileRef.current &&
      !profileRef.current.contains(event.target)
    ) {
      setPopupOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


    const token = Cookies.get("Snapta_Admin_Token")
    const {data:ProfileData,error,refetch} = useGetDetailsQuery({token:token})
    const profile = ProfileData?.user_data
    console.log("data profile !!!",profile)

    // For Theme Toggle 
    const {theme,toggleTheme} = useTheme();
    console.log("Theme @@@",theme)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    // const handlePopupClose = () => {
    //     setPopupOpen(false)
    // }

    // const [popupOpen, setPopupOpen] = useState(false);
const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

const handlePopupClose = () => setPopupOpen(false);
const handleLogoutClick = () => {
  setPopupOpen(false);       // Close the profile popup
  setLogoutDialogOpen(true); // Open the logout dialog
};

const handleDialogClose = () => setLogoutDialogOpen(false);
const handleDialogConfirm = () => {
  setLogoutDialogOpen(false);
  // Proceed with logout...
};


    const {data:NotificationData,refetch:NotificationRefetch} = useGetAllNotificationQuery({token:token})
    const TotalUnreadNotification = NotificationData?.pending_notification
    console.log("Unread !!!",TotalUnreadNotification)
    
    return (
        <>
            <div className='flex justify-between px-4 relative py-4 border-b dark:border-[#1F1F1F] xl:px-6 2xl:px-6'>
                {/* Left Section: Bars and Search Bar */}
                <div className='flex gap-3'>
                    <button onClick={() => setSidebarOpen(!sidebarOpen)}>
                        <FaBars className='w-5 h-5 dark:text-white xl:hidden' />
                    </button>

            {sidebarOpen && (
                <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            )}

            

                    <div className='flex justify-center block cursor-pointer xl:hidden place-items-center'>
                    <img src={Logo} className='w-5 h-5'/>
                    </div>

                    {/* Search Bar */}
                    <div className="sm:relative">

                        {/* Small Screen Search Button */}
                        <div className="flex items-center py-2 sm:p-2 sm:transform sm:-translate-y-1/2 sm:absolute sm:left-2 sm:top-1/2" onClick={handleOpen}>
                            <img src={Search1} alt="Search" className="w-5 h-5" />
                        </div>

                        
                        {/* opened search bar */}
                        <input
                            type="text"
                            // className="border sm:block hidden border-gray-500 bg-[#00000005] font-poppins border-opacity-10 w-[350px] rounded-lg py-1 pl-12 placeholder:text-sm placeholder:text-[#0000004F] bg-white focus:outline-none focus:ring-1 focus:ring-gray-600"
            className="border border-gray-500 xl:block hidden bg-[#00000005] dark:text-darkText border-opacity-10 rounded-lg w-[350px] py-1 pl-12 placeholder:text-sm placeholder:text-[#0000004F] placeholder:dark:text-tableDarkLarge focus:outline-none focus:ring-1 focus:ring-gray-600"
                            
                            placeholder="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}/>

                        {/* Dropdown Options */}
                        {search && filteredOptions.length > 0 && (
                            <div className="absolute z-50 w-full mt-1 bg-[#FFFFFF] border border-gray-300 rounded-lg shadow-md dark:bg-primary">
                                {filteredOptions.map((option) => (
                                    <p
                                        key={option.name}
                                        onClick={() => navigate(option.path)}
                                        className="px-4 py-2 text-sm cursor-pointer dark:text-darkText text-[#000000] font-poppins light:hover:bg-gray-100"
                                    >
                                        {option.name}
                                    </p>
                                ))}
                            </div>
                        )}
                    </div>

                    
                </div>

                {/* Right Section: Country, Notifications, Profile */}
                <div className='flex gap-2'>
                    {/* Country Flag */}

                    {/* Dark/Light Mode */}
                    <button className="flex items-center gap-2 p-2 bg-opacity-50 rounded-full bg-opacityGradient dark:bg-purple-300" onClick={toggleTheme}>
      {theme === "light" ? (
        <img className="h-5 " src={mode} alt="" />
      ) : (
        <img className="h-5 " src={Moon} alt="" />
      )}
    </button>

                    {/* Notifications */}
                    

                    <div className="relative" ref={notificationRef}>
   <button className='p-2 bg-opacity-50 rounded-full bg-opacityGradient dark:bg-purple-300' onClick={() => setOpenNotification(!openNotification)}>
                            <img src={notification} className='w-5 h-5 rounded-full cursor-pointer' />
                            {TotalUnreadNotification > 0 && <div className='rounded-full bg-[#452B7A] absolute right-1 top-0 w-2 h-2'></div>}
                        </button>
  {openNotification && (
    <div className="absolute z-50 mt-2 -right-5 md:right-0 top-full">
      <NotificationPopup className="dark:bg-primary" />
    </div>
  )}
</div>



                    {/* Profile */}
                    {/* <div className='relative' ref={notificationRef}>
                        <button className='rounded-full' onClick={() => setPopupOpen(!popupOpen)}>
                            <img src={profile?.profile_pic} className='w-8 h-8 rounded-full cursor-pointer' />
                        </button> 
                        {popupOpen && 
                        (<div className='absolute z-50 mt-2 -right-1 md:right-0 top-full'>
                          <LogoutProfilePopup className="dark:bg-primary" onClose={handlePopupClose}/>
                        </div>)}
                    </div> */}

                    <div className='relative' ref={profileRef}>
  <button className='rounded-full' onClick={() => setPopupOpen(!popupOpen)}>
    <img src={profile?.profile_pic} className='w-8 h-8 rounded-full cursor-pointer' />
  </button> 

  {popupOpen && (
    <div className='absolute z-50 mt-2 -right-1 md:right-0 top-full'>
      <LogoutProfilePopup onLogoutClick={handleLogoutClick} />
    </div>
  )}

  {/* Keep this always mounted */}
  <LogoutDialog
    open={logoutDialogOpen}
    handleClose={handleDialogClose}
    handleDelete={handleDialogConfirm}
  />
</div>




                </div>
            </div>

            <SearchDialog open={open} handleClose={handleClose}/>
        </>
    );
}

export default Search;


